import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { useAuthStore } from './store/authStore';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import { Toaster } from 'sonner';

// Restore auth session before first render
useAuthStore.getState().loadUser().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
        <Toaster richColors position="top-right" />
      </ErrorBoundary>
    </React.StrictMode>,
  );
});
